const DEFAULT_API_BASE_URL =
  process.env.NODE_ENV === "development"
    ? "https://iot-backend.trackingcoredata.com"
    : "https://iot-backend.trackingcoredata.com";

export const APP_API_BASE = (
  process.env.REACT_APP_API_BASE_URL || DEFAULT_API_BASE_URL
).replace(/\/$/, "");

export const APP_API_V1_BASE = `${APP_API_BASE}/api/v1`;
export const APP_INVENTORY_API_BASE = `${APP_API_V1_BASE}/inventory`;
export const APP_MANUFACTURING_API_BASE = `${APP_API_V1_BASE}/manufacturing`;
export const APP_WEBHOOKS_API_BASE = `${APP_API_V1_BASE}/webhooks`;

export const buildApiUrl = (path = "") =>
  `${APP_API_BASE}${path.startsWith("/") ? path : `/${path}`}`;

export const buildApiV1Url = (path = "") =>
  `${APP_API_V1_BASE}${path.startsWith("/") ? path : `/${path}`}`;

export const buildInventoryApiUrl = (path = "") =>
  `${APP_INVENTORY_API_BASE}${path.startsWith("/") ? path : `/${path}`}`;

export const buildManufacturingApiUrl = (path = "") =>
  `${APP_MANUFACTURING_API_BASE}${path.startsWith("/") ? path : `/${path}`}`;
